import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20abb932"
import script from "./actionTaken.js?vue&type=script&lang=js&external"
export * from "./actionTaken.js?vue&type=script&lang=js&external"
import style0 from "./actionTaken.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports